module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-helper', [_c('div', {
    attrs: {
      "slot": "form-header"
    },
    slot: "form-header"
  }, [_c('h2', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Anschriftsdaten")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-fields"
    },
    slot: "form-fields"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "name": "strasse",
      "label": "Strasse",
      "error": _vm.errors.has('strasse'),
      "id": "Strasse"
    },
    model: {
      value: (_vm.ad.strasse),
      callback: function($$v) {
        _vm.$set(_vm.ad, "strasse", $$v)
      },
      expression: "ad.strasse"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('strasse')),
      expression: "errors.has('strasse')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('strasse')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "name": "plz",
      "label": "PLZ",
      "error": _vm.errors.has('plz'),
      "id": "plz"
    },
    model: {
      value: (_vm.ad.plz),
      callback: function($$v) {
        _vm.$set(_vm.ad, "plz", $$v)
      },
      expression: "ad.plz"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('plz')),
      expression: "errors.has('plz')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('plz')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "name": "ort",
      "label": "Ort",
      "error": _vm.errors.has('ort'),
      "id": "ort"
    },
    model: {
      value: (_vm.ad.ort),
      callback: function($$v) {
        _vm.$set(_vm.ad, "ort", $$v)
      },
      expression: "ad.ort"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ort')),
      expression: "errors.has('ort')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('ort')))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "land",
      "label": "Land",
      "id": "land"
    },
    model: {
      value: (_vm.ad.land),
      callback: function($$v) {
        _vm.$set(_vm.ad, "land", $$v)
      },
      expression: "ad.land"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-commands"
    },
    slot: "form-commands"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.submitted
    }
  }, [_c('v-icon', {
    staticClass: "green--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/firmen",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b081cad4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adressen/editAdressen_1.vue
// module id = 343
// module chunks = 0